/* eslint-disable react/jsx-pascal-case */
import React, { useState } from "react";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ScrollBar from "../../components/scrollBar/ScrollBar";
import "../../styling/layout-components/PracticeElective.css";
import QPrompt1_1 from "../../templates/content/QPrompt1_1";
import QPrompt1_2 from "../../templates/content/QPrompt1_2";
import QPrompt1_3 from "../../templates/content/QPrompt1_3";
import QPrompt2_1 from "../../templates/content/QPrompt2_1";
import QPrompt2_2 from "../../templates/content/QPrompt2_2";
import QPrompt2_3 from "../../templates/content/QPrompt2_3";
import QPrompt2_4 from "../../templates/content/QPrompt2_4";
import QPrompt3_1 from "../../templates/content/QPrompt3_1";
import QPrompt3_2 from "../../templates/content/QPrompt3_2";
import DragDrop from "../../templates/daily-mission/DragDrop";
import DragDropMulti from "../../templates/daily-mission/DragDropMulti";
import Gapfill from "../../templates/daily-mission/Gapfill";
import MultipleChoice from "../../templates/daily-mission/MultipleChoice";
import MultipleResponse from "../../templates/daily-mission/MultipleResponse";
import VerticalGapfill from "../../templates/practice-elective/VerticalGapfill";
import VerticalMultipleChoice from "../../templates/practice-elective/VerticalMultipleChoice";
import VerticalMultipleResponse from "../../templates/practice-elective/VerticalMultipleResponse";

function DailyMissionContent({
  question,
  questions,
  seenQuestions,
  handleQuestionChange,
  selectedQuestion,
  submitAnswers,
  showEndPractice,
}) {
  const promptTemplate = question?.template?.prompt;
  const questionTemplate = question?.template?.question;
  const [nextScroll, setNextScroll] = useState(false)
  var backgroundStyle = {
    backgroundSize: "cover",
    // backgroundImage: `url(${question?.backgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    // borderRadius: "1rem",
  };

  const TemplateComponent = () => {
    switch (promptTemplate) {
      case "QPrompt1_1":
        return (
          <QPrompt1_1 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt1_2":
        return (
          <QPrompt1_2 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt1_3":
        return (
          <QPrompt1_3 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt2_1":
        return (
          <QPrompt2_1 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt2_2":
        return (
          <QPrompt2_2 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt2_3":
        return (
          <QPrompt2_3 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt2_4":
        return (
          <QPrompt2_4 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt3_1":
        return (
          <QPrompt3_1 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      case "QPrompt3_2":
        return (
          <QPrompt3_2 data={question} isLast={true} order={question.questionIndex + 1} />
        );
      default:
        return <div>Template not found</div>;
    }
  };

  const TemplateQuestion = () => {
    switch (questionTemplate) {
      case "MultipleChoice":
        return (
          <MultipleChoice
            question={question.question}
            questions={questions}
            questionId={questions.questionId}
            selectedQuestion={selectedQuestion}
            explanation={question.explanation}
            backgroundImage={question?.question.backgroundImage}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            setNextScroll={setNextScroll}
            handleQuestionChange={handleQuestionChange}
            showEndPractice={showEndPractice}
            submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
          />
        );
      case "VerticalMultipleChoice":
        return (
          <VerticalMultipleChoice
            question={question.question}
            explanation={question.explanation}
            backgroundImage={[
              question?.prompt.backgroundImage,
              question?.question.backgroundImage,
            ]}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
          />
        );

      case "VerticalMultipleResponse":
        return (
          <VerticalMultipleResponse
            question={question.question}
            explanation={question.explanation}
            backgroundImage={[
              question?.prompt.backgroundImage,
              question?.question.backgroundImage,
            ]}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
          />
        );

      case "VerticalGapfill":
        return (
          <VerticalGapfill
            question={question.question}
            explanation={question.explanation}
            backgroundImage={[
              question?.prompt.backgroundImage,
              question?.question.backgroundImage,
            ]}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
          />
        );
      case "MultipleResponse":
        return (
          <MultipleResponse
            question={question.question}
            explanation={question.explanation}
            backgroundImage={question?.question.backgroundImage}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            setNextScroll={setNextScroll}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
            questions={questions}
            questionId={questions.questionId}
            selectedQuestion={selectedQuestion}
            handleQuestionChange={handleQuestionChange}
            submitAnswers={submitAnswers}
          />
        );
      case "Gapfill":
        return (
          <Gapfill
            question={question.question}
            explanation={question.explanation}
            backgroundImage={question?.question.backgroundImage}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            setNextScroll={setNextScroll}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
            questions={questions}
            questionId={questions.questionId}
            selectedQuestion={selectedQuestion}
            handleQuestionChange={handleQuestionChange}
            submitAnswers={submitAnswers}
          />
        );
      case "DragDrop":
        return (
          <DragDrop
            question={question.question}
            explanation={question.explanation}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            setNextScroll={setNextScroll}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
            questions={questions}
            questionId={questions.questionId}
            selectedQuestion={selectedQuestion}
            backgroundImage={question?.question.backgroundImage}
            handleQuestionChange={handleQuestionChange}
            submitAnswers={submitAnswers}
          />
        );
      case "DragDropMulti":
        return (
          <DragDropMulti
            question={question.question}
            explanation={question.explanation}
            questionIndex={question.questionIndex}
            isLast={question?.isLast}
            // nextQuestion={handleSkip}
            showEndPractice={showEndPractice}
            setNextScroll={setNextScroll}
            // submitAnswers={submitAnswers}
            seenQuestions={seenQuestions}
            questions={questions}
            questionId={questions.questionId}
            selectedQuestion={selectedQuestion}
            backgroundImage={question?.question.backgroundImage}
            handleQuestionChange={handleQuestionChange}
            submitAnswers={submitAnswers}
          />
        );
      default:
        return null;
    }
  };

  return (
    <ScrollBar question={question} ischeckscroll={true.toString()}>
      <BackgroundImageFromUrl
        objectId={question?.backgroundImage}
        className="is-centered"
        style={{
          ...backgroundStyle,
          // display: "flex",
          // flexDirection: "column",
          width: "100%",
          // marginLeft: "1.5rem",
          // paddingRight: "1.5rem",
          // position: "fixed",
          // top: "10rem",
          // height: "100%",
        }}
      >
        <div className="">
          <TemplateComponent />
        </div>
        <div className="">
          <TemplateQuestion />
        </div>
        {/* {!question.isLast && (
                <button
                    className="button m-4"
                    onClick={handleSkip}
                    style={{ width: "fit-content", alignSelf: "center" }}
                >
                    Skip
                </button>
            )} */}
        {/* {question.isLast &&(
                <button
                    className="button m-4"
                    onClick={handleEndPractice}
                    style={{ width: "fit-content", alignSelf: "center" }}
                >
                    End Practice
                </button>
            )} */}
      </BackgroundImageFromUrl>
    </ScrollBar>
  );
}

export default DailyMissionContent;
